/*
 * No.9 Caffè — Product page
 *
 * Gallery: thumbnails, arrows, swipe, keyboard.
 * Buy box: size pill → variant selection (form id input, bundle prices,
 * URL ?variant=, availability), bundle card → quantity. Add-to-cart itself
 * is Dawn's <product-form> (AJAX → opens the No.9 cart drawer).
 */
(function () {
  'use strict';

  /* ---- Shopify money formatting ---------------------------- */
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision == null ? 2 : precision;
    thousands = thousands == null ? ',' : thousands;
    decimal = decimal == null ? '.' : decimal;
    if (isNaN(number) || number == null) return '0';

    var fixed = (number / 100.0).toFixed(precision);
    var parts = fixed.split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return whole + (parts[1] ? decimal + parts[1] : '');
  }

  function formatMoney(cents, format) {
    var fmt = format || '${{amount}}';
    var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return fmt;

    var value;
    switch (match[1]) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ---- Smooth accordions -----------------------------------
     <details> snaps open natively. Animate the element's height
     with the Web Animations API instead, keeping `open` correct
     for a11y and in-page search. */
  function initAccordions(section) {
    var reduceMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return; // leave the instant native behaviour

    var DURATION = 280;
    var EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';

    section.querySelectorAll('.pd-no9__acc').forEach(function (el) {
      var summary = el.querySelector('summary');
      var body = el.querySelector('.pd-no9__acc-body');
      if (!summary || !body) return;

      var animation = null;
      var isClosing = false;
      var isExpanding = false;

      function padding() {
        var cs = window.getComputedStyle(el);
        return parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom);
      }

      function settle(open) {
        el.open = open;
        animation = null;
        isClosing = false;
        isExpanding = false;
        el.style.height = '';
        el.style.overflow = '';
      }

      function run(from, to, open) {
        if (animation) animation.cancel();
        animation = el.animate(
          { height: [from + 'px', to + 'px'] },
          { duration: DURATION, easing: EASING }
        );
        animation.onfinish = function () {
          settle(open);
        };
        animation.oncancel = function () {
          isClosing = false;
          isExpanding = false;
        };
      }

      function shrink() {
        isClosing = true;
        run(el.offsetHeight, summary.offsetHeight + padding(), false);
      }

      function expand() {
        isExpanding = true;
        run(el.offsetHeight, summary.offsetHeight + body.offsetHeight + padding(), true);
      }

      summary.addEventListener('click', function (evt) {
        evt.preventDefault();
        el.style.overflow = 'hidden';

        if (isClosing || !el.open) {
          // Open first so the body can be measured, then animate.
          el.style.height = el.offsetHeight + 'px';
          el.open = true;
          window.requestAnimationFrame(expand);
        } else if (isExpanding || el.open) {
          shrink();
        }
      });
    });
  }

  function init(section) {
    initAccordions(section);
    /* ================= Gallery ================= */
    var gallery = section.querySelector('[data-pd-gallery]');
    if (gallery) {
      var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-pd-slide]'));
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-pd-thumb]'));
      var track = gallery.querySelector('[data-pd-slides]');
      var stageEl = gallery.querySelector('.pd-no9__stage');
      var current = 0;
      var EASE = 'transform 0.38s cubic-bezier(0.4, 0, 0.2, 1)';

      // One slide + the gap between them. Cached — reading computed styles
      // on every pointermove is what makes a drag feel laggy.
      var stepPx = 0;
      var measure = function () {
        if (!stageEl) return 0;
        var cs = window.getComputedStyle(track);
        var gap = parseFloat(cs.columnGap || cs.gap) || 0;
        stepPx = stageEl.clientWidth + gap;
        return stepPx;
      };
      var step = function () {
        return stepPx || measure();
      };

      var applyX = function (px, animate) {
        if (!track) return;
        track.style.transition = animate ? EASE : 'none';
        track.style.transform = 'translate3d(' + px + 'px, 0, 0)';
      };

      var prevBtn = gallery.querySelector('[data-pd-prev]');
      var nextBtn = gallery.querySelector('[data-pd-next]');

      // The track clamps rather than wraps, so an arrow at either end does
      // nothing. Disable it there and let the CSS dim it — the dimming has to
      // follow the position, not be baked into the prev arrow.
      var syncArrows = function () {
        var last = slides.length - 1;
        if (prevBtn) prevBtn.disabled = current <= 0;
        if (nextBtn) nextBtn.disabled = current >= last;
      };

      var show = function (index, animate) {
        if (!slides.length) return;
        // Clamp rather than wrap — a flex track can't loop without a jump
        current = Math.max(0, Math.min(slides.length - 1, index));
        applyX(-current * step(), animate !== false);
        slides.forEach(function (s, i) {
          s.classList.toggle('is-active', i === current);
        });
        thumbs.forEach(function (t, i) {
          t.classList.toggle('is-active', i === current);
        });
        syncArrows();
      };

      // Position without animating on load and whenever the width changes
      measure();
      show(0, false);

      var reflow = function () {
        measure();
        applyX(-current * stepPx, false);
      };
      window.addEventListener('resize', reflow);
      // Fires when the stage itself changes width (sticky column, zoom,
      // font swap) — resize alone misses those.
      if (window.ResizeObserver && stageEl) {
        new window.ResizeObserver(reflow).observe(stageEl);
      }
      // Images finishing late must not leave the track mispositioned
      window.addEventListener('load', reflow);

      if (prevBtn) prevBtn.addEventListener('click', function () { show(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { show(current + 1); });

      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          show(parseInt(t.getAttribute('data-pd-thumb'), 10));
        });
      });

      // Keyboard
      gallery.addEventListener('keydown', function (evt) {
        if (evt.key === 'ArrowLeft') { show(current - 1); }
        if (evt.key === 'ArrowRight') { show(current + 1); }
      });

      /* ---- Drag / swipe (mouse AND touch) --------------------
         The whole track follows the pointer 1:1, so the neighbouring
         image is visibly dragged into view, then snaps to the nearest
         slide on release. `touch-action: pan-y` on the stage keeps
         vertical page scrolling intact on phones. */
      var stage = stageEl;
      if (stage && slides.length > 1) {
        var startX = null;
        var startY = null;
        var axis = null; // 'x' once the gesture is clearly horizontal

        var pointerId = null;

        var release = function (endX) {
          if (startX == null) return;
          var dx = endX == null ? 0 : endX - startX;

          if (pointerId != null && stage.releasePointerCapture) {
            try {
              stage.releasePointerCapture(pointerId);
            } catch (e) {
              /* already released */
            }
          }
          pointerId = null;
          startX = null;
          startY = null;
          axis = null;
          stage.classList.remove('is-dragging');

          // Commit past ~18% of a slide, otherwise settle back
          var threshold = Math.min(80, stepPx * 0.18);
          if (Math.abs(dx) > threshold) show(dx < 0 ? current + 1 : current - 1);
          else show(current);
        };

        stage.addEventListener('pointerdown', function (evt) {
          // Ignore drags that begin on the arrows
          if (evt.target.closest && evt.target.closest('.pd-no9__arrow')) return;
          if (startX != null) return; // a gesture is already running
          if (evt.pointerType === 'mouse') {
            if (evt.button !== 0) return;
            evt.preventDefault(); // stop native image drag / text selection
            axis = 'x'; // a mouse drag is always horizontal intent
          }
          measure(); // width may have changed since the last gesture
          startX = evt.clientX;
          startY = evt.clientY;

          // Capture so move/up still reach us if the pointer leaves the
          // stage (or the window) mid-drag — otherwise the drag sticks.
          if (stage.setPointerCapture) {
            try {
              stage.setPointerCapture(evt.pointerId);
              pointerId = evt.pointerId;
            } catch (e) {
              /* capture unsupported — pointerleave below covers it */
            }
          }
          stage.classList.add('is-dragging');
        });

        stage.addEventListener('pointermove', function (evt) {
          if (startX == null) return;
          var dx = evt.clientX - startX;

          if (!axis) {
            if (Math.abs(dx) > Math.abs(evt.clientY - startY) && Math.abs(dx) > 6) axis = 'x';
            else if (Math.abs(evt.clientY - startY) > 10) {
              // Vertical scroll — hand the gesture back
              release(null);
              return;
            }
          }

          if (axis === 'x') {
            // Rubber-band at the two ends so the strip can't be pulled
            // off into empty space
            var offset = dx;
            if ((current === 0 && dx > 0) || (current === slides.length - 1 && dx < 0)) {
              offset = dx * 0.3;
            }
            applyX(-current * stepPx + offset, false);
          }
        });

        stage.addEventListener('pointerup', function (evt) {
          release(evt.clientX);
        });
        stage.addEventListener('pointercancel', function () {
          release(null);
        });
        // Only needed where setPointerCapture is unavailable
        stage.addEventListener('pointerleave', function (evt) {
          if (startX != null && pointerId == null) release(evt.clientX);
        });

        // Fallback for browsers without Pointer Events (older Safari)
        if (!window.PointerEvent) {
          stage.addEventListener(
            'touchstart',
            function (evt) {
              startX = evt.changedTouches[0].clientX;
              startY = evt.changedTouches[0].clientY;
            },
            { passive: true }
          );
          stage.addEventListener('touchend', function (evt) {
            release(evt.changedTouches[0].clientX);
          });
        }
      }

      var showMedia = function (mediaId) {
        if (!mediaId) return;
        var idx = slides.findIndex(function (s) {
          return s.getAttribute('data-media-id') === String(mediaId);
        });
        if (idx > -1) show(idx);
      };
    }

    /* ================= Buy box ================= */
    var dataEl = section.querySelector('[data-pd-data]');
    if (!dataEl) return;

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var variants = data.variants || [];
    var moneyFmt = data.moneyFormat;
    var variantInput = section.querySelector('[data-pd-variant-input]');
    var qtyInput = section.querySelector('[data-pd-qty-input]');
    var atc = section.querySelector('[data-pd-atc]');
    // Read the label from its own span so the appended price isn't captured.
    var atcTextEl = atc ? atc.querySelector('[data-pd-atc-text]') : null;
    // Both labels come from the theme (data attributes on the button), so they
    // follow the store language and the block setting. The rendered text is
    // only a fallback for markup cached from before the attributes existed.
    var atcText =
      (atc && atc.getAttribute('data-pd-atc-label')) ||
      (atcTextEl ? atcTextEl.textContent.trim() : 'Dodaj v košarico');
    var soldOutText = (atc && atc.getAttribute('data-pd-sold-out-label')) || 'Razprodano';

    var currentVariant =
      variants.find(function (v) {
        return variantInput && String(v.id) === String(variantInput.value);
      }) || variants[0];

    // Which option position do the size pills control?
    var sizePills = Array.prototype.slice.call(section.querySelectorAll('[data-pd-size]'));
    var optionIndex = 0;
    if (sizePills.length && variants.length) {
      var probe = sizePills[0].getAttribute('data-pd-size');
      for (var j = 0; j < variants[0].options.length; j++) {
        var hit = variants.some(function (v) { return v.options[j] === probe; });
        if (hit) { optionIndex = j; break; }
      }
    }

    function selectedQty() {
      return qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    }

    // Totals for the currently selected bundle + size.
    function currentTotals() {
      var active = section.querySelector('[data-pd-bundle].is-selected');
      var qty = active ? parseInt(active.getAttribute('data-pd-bundle'), 10) || 1 : 1;
      var pct = active ? parseFloat(active.getAttribute('data-pd-discount')) || 0 : 0;

      var gross = currentVariant.price * qty;
      // Shopify floors the discount on each unit and then multiplies, rather
      // than taking the percentage off the line total — the two differ by a
      // cent whenever unit x pct lands on a half.
      var save = pct > 0 ? Math.floor((currentVariant.price * pct) / 100) * qty : 0;
      var net = gross - save;

      // No bundle discount? Fall back to the variant's compare-at price.
      if (save === 0 && currentVariant.compareAtPrice > currentVariant.price) {
        gross = currentVariant.compareAtPrice * qty;
        save = gross - net;
      }
      return { gross: gross, save: save, net: net };
    }

    // Price shown inside the Add to cart button (Figma 432:194).
    function paintButtonPrice() {
      var priceEl = section.querySelector('[data-pd-atc-price]');
      if (!priceEl || !currentVariant || !atc) return;

      // Mirrors the Liquid: non-breaking spaces around the separator, since
      // Shopify strips real spaces from the text setting.
      var sep = (atc.getAttribute('data-pd-atc-separator') || '').trim();
      var money = formatMoney(currentTotals().net, moneyFmt);
      priceEl.textContent = (sep ? ' ' + sep : '') + ' ' + money;
    }

    // Optional headline price block — reflects the selected bundle AND size.
    function paintHeadlinePrice() {
      paintButtonPrice();

      var block = section.querySelector('[data-pd-price-block]');
      if (!block || !currentVariant) return;

      var totals = currentTotals();
      var gross = totals.gross;
      var save = totals.save;
      var net = totals.net;

      var nowEl = block.querySelector('[data-pd-price-now]');
      if (nowEl) nowEl.textContent = formatMoney(net, moneyFmt);

      var wasEl = block.querySelector('[data-pd-price-was]');
      if (wasEl) {
        wasEl.textContent = formatMoney(gross, moneyFmt);
        wasEl.hidden = save <= 0;
      }

      var saveEl = block.querySelector('[data-pd-price-save]');
      if (saveEl) {
        var label = block.getAttribute('data-pd-save-label') || 'Save';
        saveEl.textContent = label + ' ' + formatMoney(save, moneyFmt);
        saveEl.hidden = save <= 0;
      }
    }

    function paintPrices() {
      if (!currentVariant) return;
      section.querySelectorAll('[data-pd-bundle]').forEach(function (card) {
        var q = parseInt(card.getAttribute('data-pd-bundle'), 10) || 1;
        var pct = parseFloat(card.getAttribute('data-pd-discount')) || 0;

        // Mirrors the Liquid maths (integer cents, floored per unit then
        // multiplied) so the page, the JS and the cart all agree.
        var gross = currentVariant.price * q;
        var save = pct > 0 ? Math.floor((currentVariant.price * pct) / 100) * q : 0;

        // Per-unit unless the card asks for the total. Floors to match the
        // Liquid `divided_by`, which does integer division — rounding here
        // would make the price shift by a cent on the first size change.
        var net = gross - save;
        var mode = card.getAttribute('data-pd-price-mode') || 'unit';
        // Cups in one pack (capsules: one capsule = one cup). 0 for beans,
        // whose cups are worked out from the bag weight further down.
        var cups = parseInt(card.getAttribute('data-pd-cups'), 10) || 0;
        var shown;
        if (mode === 'total') shown = net;
        else if (mode === 'cup' && cups > 0) shown = Math.floor(Math.floor(net / q) / cups);
        else shown = Math.floor(net / q);
        var suffix = mode === 'total' ? '' : (card.getAttribute('data-pd-unit-suffix') || '');

        var priceEl = card.querySelector('[data-pd-bundle-price]');
        if (priceEl) priceEl.textContent = formatMoney(shown, moneyFmt) + suffix;

        // Whichever second line this card renders gets repainted. Both lookups
        // are guarded, so a card showing savings simply has no cup element and
        // vice versa; the JS does not need to know which mode is set.
        var amountEl = card.querySelector('[data-pd-save-amount]');
        if (amountEl) amountEl.textContent = formatMoney(save, moneyFmt);

        // Price per cup. Mirrors the Liquid exactly: per-bag net floored, then
        // multiplied by grams-per-cup and divided by the variant weight, floored
        // again. The weight is the variant's, not the size label's, because the
        // Duo's "250g" variant is two bags and weighs 500 g.
        var cupWrap = card.querySelector('[data-pd-bundle-cup]');
        if (cupWrap) {
          var gramsPerCup = parseInt(card.getAttribute('data-pd-cup-grams'), 10) || 9;
          var grams = currentVariant.grams || 0;
          var unitNet = Math.floor(net / q);
          var perCup = 0;
          if (cups > 0) perCup = Math.floor(unitNet / cups);
          else if (grams > 0) perCup = Math.floor((unitNet * gramsPerCup) / grams);
          var cupAmt = cupWrap.querySelector('[data-pd-cup-amount]');
          if (cupAmt) cupAmt.textContent = formatMoney(perCup, moneyFmt);
          cupWrap.hidden = perCup <= 0;
        }
      });

      paintHeadlinePrice();
    }

    function paintAvailability() {
      if (!atc) return;
      var ok = currentVariant && currentVariant.available;
      atc.disabled = !ok;
      var textEl = atc.querySelector('[data-pd-atc-text]');
      var priceEl = atc.querySelector('[data-pd-atc-price]');

      if (ok) {
        atc.removeAttribute('aria-disabled');
        if (textEl) textEl.textContent = atcText;
        if (priceEl) priceEl.hidden = false;
      } else {
        atc.setAttribute('aria-disabled', 'true');
        if (textEl) textEl.textContent = soldOutText;
        if (priceEl) priceEl.hidden = true; // no price on a sold-out button
      }
    }

    function setVariant(variant) {
      if (!variant) return;
      currentVariant = variant;
      if (variantInput) variantInput.value = variant.id;
      paintPrices();
      paintAvailability();
      if (typeof showMedia === 'function') showMedia(variant.mediaId);

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    // Size pills
    sizePills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        // A sold-out size is rendered disabled, which already stops the click;
        // this is the belt to that, should the attribute ever be lost.
        if (pill.disabled || pill.classList.contains('is-unavailable')) return;
        var value = pill.getAttribute('data-pd-size');
        if (!currentVariant) return;

        var want = currentVariant.options.slice();
        want[optionIndex] = value;

        var match = variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === want[i]; });
        });
        if (!match) {
          // fall back to any variant carrying this value
          match = variants.find(function (v) { return v.options[optionIndex] === value; });
        }
        if (!match) return;

        sizePills.forEach(function (p) {
          var on = p === pill;
          p.classList.toggle('is-selected', on);
          p.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        setVariant(match);
      });
    });

    // Bundles
    var bundles = Array.prototype.slice.call(section.querySelectorAll('[data-pd-bundle]'));

    // The posted quantity always mirrors the selected card. This used to be set
    // only in the branch that runs when nothing is preselected, so a card marked
    // selected by Liquid left the hidden input on whatever the template
    // rendered — the shopper saw one bundle and the cart received another.
    var syncQty = function () {
      if (!qtyInput) return;
      var selected = section.querySelector('[data-pd-bundle].is-selected');
      if (!selected) return;
      qtyInput.value = parseInt(selected.getAttribute('data-pd-bundle'), 10) || 1;
    };

    if (bundles.length && !bundles.some(function (b) { return b.classList.contains('is-selected'); })) {
      bundles[0].classList.add('is-selected');
    }
    syncQty();

    bundles.forEach(function (card) {
      card.addEventListener('click', function () {
        bundles.forEach(function (c) { c.classList.toggle('is-selected', c === card); });
        syncQty();
        paintHeadlinePrice();
      });
    });

    paintPrices();
    paintAvailability();
  }

  document.querySelectorAll('[data-pd-section]').forEach(init);
})();
